import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AiPrompt} from "../../../../Model/aiprompt";
import {Product} from "../../../../Model/Catalog/Product";
import {LoginService} from "../../../../Services/login.service";
import {AiPromptsService} from "../../../../Services/aiprompt.service";
import {SystemService} from "../../../../Services/system.service";
import {TemplateService} from "../../../../Services/template.service";
import {InvoiceService} from "../../../../Services/invoice.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'np-product-description-wizard',
    templateUrl: './product-description-wizard.component.html',
    styleUrls: ['./product-description-wizard.component.css'],
    standalone: false
})
export class ProductDescriptionWizardComponent {
  @Input() model: Product;
  @Output() modelChange = new EventEmitter<Product>();

  prompt: AiPrompt;
  field: string;

  loading = false;
  promptResult;
  promptResultEntries: { field: string; label: string; value: string; confidence?: number }[] = [];

  constructor(
    public loginService: LoginService,
    public promptService: AiPromptsService,
    public systemService: SystemService,
    public templateService: TemplateService,
    public invoiceServce: InvoiceService,
    public translate: TranslateService
  ) {
    this.confirmGenerate = this.confirmGenerate.bind(this);
    this.applyResult = this.applyResult.bind(this);
  }

  private buildPromptResultEntries(): { field: string; label: string; value: string; confidence?: number }[] {
    if (!this.promptResult) return [];

    let parsed: any;
    try {
      parsed = JSON.parse(this.promptResult);
    } catch {
      return [{ field: null, label: null, value: this.promptResult }];
    }

    if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
      return [{ field: null, label: null, value: this.promptResult }];
    }

    const confidence = parsed.confidence && typeof parsed.confidence === 'object' ? parsed.confidence : null;

    return Object.keys(parsed)
      .filter((field) => field !== 'confidence')
      .map((field) => ({
        field,
        label: this.translate.instant(field),
        value: parsed[field] == null ? '' : typeof parsed[field] === 'string' ? parsed[field] : JSON.stringify(parsed[field]),
        confidence: confidence ? confidence[field] : undefined
      }));
  }


  async confirmGenerate() {
    this.loading = true;
    try {
      const resp = await this.promptService.usePrompt(
        this.prompt,
        this.model.id,
        this.loginService.currentCustomer.id
      );
      this.promptResult = typeof resp === 'string' ? resp : resp?.result;
    } catch (err: any) {
      this.systemService.notifyWarning(
        err?.error?.message ?? err?.error?.detail ?? err?.message ?? 'Fehler beim Generieren.'
      );
    } finally {
      this.promptResultEntries = this.buildPromptResultEntries();
      this.loading = false;
    }
  }

  trackByField(index: number, entry: { field: string }): string | number {
    return entry.field ?? index;
  }

  confidenceColorClass(confidence: number): string {
    const calcValue = Math.round(Math.min(100, Math.max(0, confidence)) / 25) * 25;
    switch (calcValue) {
      case 0: return 'confidence-low';
      case 25: return 'confidence-lowMid';
      case 50: return 'confidence-mid';
      case 75: return 'confidence-highMid';
      default: return 'confidence-high';
    }
  }

  async applyResult() {
    await this.promptService.applyPromptResult(
      this.promptResult,
      this.field,
      this.model.id,
      this.loginService.currentCustomer.id,
      this.prompt.nextPimTargetFields
    );
    this.modelChange.emit(this.model);
  }

}
